//@flow
import React, { Fragment, Component } from 'react';
import LazyLoad from 'react-lazyload';

import {
  companyLinks,
  socialMediaLinks,
  emails,
  address,
  footerQuotes,
  featuredByList,
} from './data';
import config from '../../config';

const basicClassName = 'indicator indicator--small';
const classNameWithHover = `${basicClassName} hover`;

const footerStyle = {
  // position: '-webkit-sticky',
  position: 'sticky',
  bottom: '0',
  height: '0px',
  padding: '5px 0',
  zIndex: '-1',
};

type FooterIndicatorProps = {
  highLight: boolean,
  quoteNumber: Number,
};

const OFFSET = 175;

const FooterIndicator = ({ highLight, quoteNumber }: FooterIndicatorProps) => (
  <div className={highLight ? 'd-lg-none' : 'd-none d-lg-block'}>
    <div className="indicators">
      {footerQuotes.map((list, i) => (
        <div
          key={list.author}
          className={
            highLight
              ? quoteNumber === i
                ? classNameWithHover
                : basicClassName
              : `indicator indicator--${i + 1} indicator--right`
          }
        >
          <div className="indicator-content">
            ‘{list.quote_1}
            <br />
            {list.quote_2}.’
            <br />
            <small>- {list.author}</small>
          </div>
        </div>
      ))}
    </div>
  </div>
);

type State = {
  quoteNumber: number,
};

export default class Footer extends Component<{}, State> {
  state = { quoteNumber: 0 };

  componentDidMount() {
    setInterval(this.changeQuote, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.changeQuote);
  }

  changeQuote = () => {
    const { quoteNumber: currentQuote } = this.state;
    const nextQuote = currentQuote > 1 ? 0 : currentQuote + 1;

    this.setState({ quoteNumber: nextQuote });
  };

  render() {
    const { quoteNumber } = this.state;

    return (
      <div className="footerAll" style={footerStyle}>
        <section className="section section--white teaser py-5">
          <div className="container">
            <h2 className="text-uppercase text-center section-header">
              We are featured by
            </h2>
            <div className="row mt-4">
              {featuredByList.map(v => (
                <div
                  key={v.href}
                  className="col-6 col-sm-4 col-md mt-3 mt-md-0"
                >
                  <a
                    href={v.href}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    <LazyLoad offset={OFFSET}>
                      <img src={v.imgSrc} alt="LP" />
                    </LazyLoad>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section id="teaser" className="section section--white teaser">
          <LazyLoad offset={OFFSET}>
            <img
              src={`${config.ASSETS_URL}/everest_kalapathar.jpg`}
              alt="mountain teaser"
              className="background-mountains"
            />
          </LazyLoad>
          <LazyLoad offset={OFFSET}>
            <img
              src={`${config.ASSETS_URL}/tree.png`}
              alt="trees"
              className="overlay-trees"
            />
          </LazyLoad>
          <FooterIndicator highLight={false} />
          <FooterIndicator highLight={true} quoteNumber={quoteNumber} />
        </section>
        <footer className="footer">
          <div className="footer-background">
            <div className="container">
              <div className="row mb-5 pb-5">
                <div className="col-md-6 col-lg-2" />
                <div className="col-md-6 col-lg-3">
                  <h5 className="mb-3">Company</h5>
                  <ul className="footer-menu">
                    {companyLinks.map(({ text, link }) => (
                      <li key={text}>
                        <a href={link}>{text}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-md-6 col-lg-3 mt-5 mt-md-0">
                  <h5 className="mb-3">Contact Us</h5>
                  {emails.map(({ text, email, number }) => (
                    <Fragment key={text}>
                      <div className="gray-h6-inside mb-4">
                        <h6 className="mb-0" style={{ color: '#fff' }}>
                          {text}
                        </h6>
                        <a href={`mailto:${email}`}>{email}</a>
                        <h6>{number}</h6>
                      </div>
                    </Fragment>
                  ))}
                  {address.map(({ country, address1, address2 }) => (
                    <Fragment key={country}>
                      <div className="gray-h6-inside mb-3">
                        <h6 className="mb-0" style={{ color: '#fff' }}>
                          <u>{country}</u>
                        </h6>
                        <h6 className="mb-0">{address1}</h6>
                        <h6 className="mb-0">{address2}</h6>
                      </div>
                    </Fragment>
                  ))}
                </div>
                <div className="col-md-6 col-lg-4 mt-5 mt-md-0">
                  <h5 className="mb-3">Follow Us</h5>
                  <div className="mb-4">
                    {socialMediaLinks.map(({ link, text }) => (
                      <a
                        key={text}
                        href={link}
                        className="footer-social"
                        target="_blank"
                        rel="noopener"
                      >
                        <LazyLoad offset={OFFSET}>
                          <img
                            src={`${config.ASSETS_URL}/${text}.png`}
                            alt={text}
                          />
                        </LazyLoad>
                      </a>
                    ))}
                  </div>
                  <h5 className="mb-3">Secure Payments By</h5>
                  <div className="footer-payments">
                    <LazyLoad offset={OFFSET}>
                      <img
                        src="https://s3.amazonaws.com/honeyguide/assets/stripe-powered-white.png"
                        alt=""
                      />
                    </LazyLoad>
                  </div>
                </div>
              </div>
              <div className="footer-responsive-separator" />
            </div>
          </div>
          <div className="container footer-brand-container">
            <div className="row">
              <div className="col">
                <div className="footer-brand">
                  <LazyLoad offset={OFFSET}>
                    <img
                      src={`${config.ASSETS_URL}/newlogo.png`}
                      alt="logo"
                      className="footer-logo"
                    />
                  </LazyLoad>
                  <hr />
                  &copy; 2021 HoneyGuide
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx